import { OpendoorLogoSvg } from '@opendoor/mosaic';
import { WEB_URL } from '../utils/constants';
import HorizontalLayout from './layouts/HorizontalLayout';
import './NavigationBar.css';

interface TextLinkProps {
  href: string;
  text: string;
  target?: string;
  tradePartnerPortal?: boolean;
}

const TextLink = ({ href, text, target, tradePartnerPortal }: TextLinkProps) => {
  const url = tradePartnerPortal ? '' : WEB_URL;
  return (
    <a
      href={`${url}${href}`}
      target={target}
      className="AdminGray"
      style={{
        padding: 15,
        backgroundColor: 'transparent',
        float: 'left',
        fontSize: 14,
        fontFamily: 'Roboto',
      }}
    >
      {text}
    </a>
  );
};

const NavigationBar = () => {
  return (
    <HorizontalLayout
      className="justify-between"
      style={{
        backgroundColor: '#eaebeb',
        boxShadow: 'inset 0 -1px rgb(0 0 0 / 10%)',
        minHeight: 50,
        lineHeight: '20px',
      }}
    >
      <link rel="stylesheet" href={'https://fonts.googleapis.com/css?family=Roboto'} />
      <HorizontalLayout>
        <OpendoorLogoSvg color="blue4" style={{ width: 20, height: 20, padding: 15 }} />
        <TextLink href="/vendor/work-orders?filter=new" text="Work Orders" />
        <TextLink href="/vendor/on-site-workers" text="On-Site Workers" />
        <TextLink href="/vendor/inspections" text="Inspections" />
        <TextLink href="/vendor/maintenance" text="Maintenance" />
        <TextLink href="/vendor/photography" text="Photography" />
        <TextLink href="/vendor/invoices" text="Invoices" />
        <TextLink href="/vendor/external-listings" text="External Listings" />
        <TextLink href="/on-site" text="Link to On-Site Portal" target="_blank" />
      </HorizontalLayout>
      <HorizontalLayout>
        <TextLink href="/" text="Vendor Profile" target="_blank" tradePartnerPortal />
        <TextLink href="/vendor-help" text="Help Center" target="_blank" />
        <TextLink href="/logout" text="Sign out" />
      </HorizontalLayout>
    </HorizontalLayout>
  );
};

export default NavigationBar;
